/// <reference path="../../../../typings/globals/jquery/index.d.ts" />
/**
 * Obsługuje formularze dodające do koszyka
 * * Klasy inputow: atc_quantity,
 *
 * @export
 * @class AddToCart
 */
import { Inputs } from "../forms/Inputs.class";
import { SimpleCart } from "./SimpleCart.class";

export class AddToCart {
	constructor() {
		this.forms = null;
		this.isRefreshCartCounterTriggerd = false;
		this.cartCounterTimer = false;
		this.forms = null;
		this.cart = new SimpleCart();
	}
	isActive() {
		return this.forms.length > 0;
	}
	// ****************************************************************************************************
	// Inicjalizacja kafelkow AddToCart
	// ****************************************************************************************************
	init() {
		var that = this;
		that.forms = $('.addToCartForm');
		//that.refreshCartCounter();
		if (that.isActive()) {
			that.forms.each(function (i, f) {
				var okBtn = $(f).find('.btnAddToCart');
				var input = $(f).find('.atc_quantity');
				var limitQuantity = Number(input.data('limit-quantity')); // outlet
				input.data('lastValue', input.val());
				var inputObj = new Inputs();
				inputObj.initQuantityInput(input);
				okBtn.off().on('click', function (event) {
					event.stopPropagation();

					if ( HIDE_PRICE ) {
						$('#myAccountBtn').trigger('click').trigger('mouseout');
					} else if ( limitQuantity && limitQuantity < Number(input.val()) ) { // outlet
						//toolsObj.showModalAlert(TXT_OUTLET_MSG_LIMIT_REACHED, TXT_OUTLET_NAME, function(){okBtn.trigger('click')} );
						var outletMsg = TXT_OUTLET_MSG_PRODUCT_LIMIT_REACHED;
						toolsObj.showModalAlert(outletMsg.replace("<b>__product__</b><br><br>", "").replace("__before__", Number(input.val())).replace("__after__", limitQuantity), TXT_OUTLET_NAME, function(){okBtn.trigger('click')} ); // wersja z ilościami
						//toolsObj.showModalAlert(outletMsg.replace("<b>__product__</b><br><br>", "").replace("__before__", Number(input.val())).replace("__after__", limitQuantity), TXT_OUTLET_NAME ); // wersja z ilościami bez automatycznego dodawania do koszyka

						input.val(limitQuantity);
					} else
						that.prepareAddToCart(f);
				});
				input.on('click', function (event) {
					event.stopPropagation();
				}).on('change', function () {
					//this.value = toolsObj.removeWhitespace(this.value);
					//this.value = toolsObj.removeLetters(this.value);
					//this.value = toolsObj.convertFloatSeparator(this.value);
				}).on('keydown', function (event) {
					input.val(toolsObj.convertFloatSeparator(input.val()));
					if ( event.keyCode == 13 ) {
						input.data('isValidationBlocked', true); // zapobiega podwojnej walidacji po enter
						event.preventDefault();
						event.stopPropagation();
						okBtn.trigger('click');
					}
				});
				if ($('.quantityDiscounts').length > 0)
					that.initQuantityDiscountBtns();
			});
		}
		if ( HIDE_PRICE ) {
			$('.showLoginModal').off().on('click', function (event) {
				event.stopPropagation();
				event.preventDefault();
				$('#myAccountBtn').trigger('click').trigger('mouseout');
			});
		}
	}
	// ****************************************************************************************************
	// Spr., czy ilość jest zgodna z precyzją (minimalną wielokrotnością zamawianej ilości) ToDo: usunac - zasapic walidacja inputu z klasy Inputs
	// ****************************************************************************************************
	isCorrectValue(value, precision) {
		var that = this;
		if (toolsObj.isPositiveFloat(value)) {
			var factor = 10000;
			return (toolsObj.roundTo(factor * value, 0) % toolsObj.roundTo(factor * precision, 0)) == 0;
		}
		else {
			return false;
		}
	}
	// ****************************************************************************************************
	// Prosta walidacja elementu ToDo: usunac - zasapic walidacja inputu z klasy Inputs
	// ****************************************************************************************************
	validateElement(e, silentMode) {
		var that = this;
		if (that.isCorrectValue(e.value, e.form.prec.value)) {
			return true;
		}
		else {
			if (!silentMode) {
				toolsObj.showModalAlert('<p class="mb-1">' + TXT_WRONG_QUANTITY + ':</p> <p class="h5 mb-0">' + e.form.prec.value + '</p>');
				e.focus();
				e.select();
			}
			return false;
		}
	}
	// ****************************************************************************************************
	// Akcja zatwierdzenia dodania do koszyka
	// ****************************************************************************************************
	prepareAddToCart(f) {
		var that = this;
		if (f.zabroniony.value != 'T') {
			if (f.zabroniony.value != 'T')
				that.addProductToCart(f);
			else
				that.askPrice(f);
		}
		else {
			that.forbiddenSale(f);
		}
	}
	// ****************************************************************************************************
	// Dodanie produktu do koszyka
	// ****************************************************************************************************
	addProductToCart(f) {
		var that = this;
		if (f.ilosc.value == '') {
			f.ilosc.value = f.prec.value;
		}
		if (that.validateElement(f.ilosc)) {
			var pageUrl = '/cart?' + $(f).serialize();
			$.ajax({
				url: pageUrl,
				beforeSend: function () {
					toolsObj.addLoadingPanel();
					$("<div id='modalDIV'></div>").appendTo($('body'));
				},
				success: function (data) {
					$('#modalDIV').html(data);
					f.ilosc.setAttribute('data-isValidationBlocked', false);
				},
				complete: function () {
					toolsObj.removeLoadingPanel();
					$('#modalAddToCart').modal('show');
					that.cart.forceRefreshCartCounter();
					sendEventToGA('AddCart', 'Click', 'AddToCartProductPage');
					$('#modalAddToCart').on('hidden.bs.modal', function (e) {
						$(this).modal('dispose');
						$("#modalDIV").remove();
					});
				}
			});
		}
		return false;
	}
	// ****************************************************************************************************
	// Wyświetanie informacji o towarze w zapowiedzi
	// ****************************************************************************************************
	askPrice(f) {
		var that = this;
		//ToDo ogarnac -> zrodlo danych askPrice.vm
		toolsObj.showModalAlert( TXT_INDIVIDUAL_PRICE );
	}
	// ****************************************************************************************************
	// Wyświetanie informacji o towarze zabronionym
	// ****************************************************************************************************
	forbiddenSale(f) {
		var that = this;
		//ToDo ogarnac -> zrodlo danych askPrice.vm
		toolsObj.showModalAlert( TXT_SALES_FORBIDDEN );
	}
	// ****************************************************************************************************
	// Inicjalizacja przycisków w rabatach ilościowych
	// ****************************************************************************************************
	initQuantityDiscountBtns() {
		var that = this;
		var btns = $('.quantityDiscountBtn');
		btns.each(function (i, e) {
			$(e).off().on('click', function () {
				var theForm = $('#productForm-' + $(e).data('target'));
				theForm.find('input.atc_quantity').val($(e).data('quantity'));
				theForm.find('span.btn').trigger('click');
			});
		});
	}
}